import Immutable from 'immutable';
import React, { ReactElement } from 'react';
import { Submittal, SubmittalOrderedMap } from 'records/Submittal';
import ApprovedSubmittalFolder from './ApprovedSubmittalFolder';

const ApprovedSubmittalFolderRenderer = (
  style: React.CSSProperties,
  index: number,
  data: Immutable.OrderedMap<string, SubmittalOrderedMap>,
  selectedSpecNumber: string,
  onSelectSpecNumber: (nextSpecNumber: string) => void
): ReactElement => {
  const submittal =
    data.valueSeq().get(index) || Immutable.OrderedMap<string, Submittal>();

  return submittal ? (
    <ApprovedSubmittalFolder
      style={style}
      key={index}
      selectedSpecNumber={selectedSpecNumber}
      onSelectSpecNumber={onSelectSpecNumber}
      submittal={submittal}
    />
  ) : (
    <div />
  );
};

export default ApprovedSubmittalFolderRenderer;
